import React from 'react';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';
import { closeJobDescription } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const CloseJobDescriptionForm = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { onResponse, onError, closeCloseJobDescriptionModal } = useBiopharmaGroupActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const title = biopharmaGroupState?.closeJobDescription?.title || 'this job description';

  const handleSubmit = () => {
    closeJobDescription({
      onResponse,
      onError,
      body: {
        authenticityToken,
        closeJobDescription: biopharmaGroupState?.closeJobDescription,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormInstruction>
        Are you sure you want to close <strong>{title}</strong>? Closed job descriptions will not be included in future match score calculations or job prospect creation.
      </FormInstruction>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeCloseJobDescriptionModal()}
          >
            Cancel
          </Button>
          <Button type="submit">
            Close Job Description
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default CloseJobDescriptionForm;
